import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function SectionOne({
  onGetInTouchClick,
}: {
  onGetInTouchClick: () => void;
}) {
  return (
    <div className="relative h-full min-h-0 w-full px-6 pt-[80px] sm:px-12 md:px-20 lg:px-32 xl:px-[200px]">
      <div className="relative w-full space-y-[120px]">
        <div className="max-w-[1064px] space-y-8">
          <div className="space-y-1 text-neutral-800">
            <h1 className="font-newsreader text-5xl leading-none font-bold -tracking-wide sm:text-6xl md:text-7xl lg:text-[80px]">
              Complete media intelligence{" "}
              <span className="bg-gradient-to-r from-[#FFA038] to-[#F97316] bg-clip-text text-transparent">
                across the Philippines
              </span>
            </h1>
            <p className="text-lg leading-normal font-medium sm:text-xl md:text-2xl">
              Know what's being said about your brand, industry, and
              competition.
            </p>
          </div>
          <div className="flex w-fit flex-col gap-3 sm:flex-row">
            <Button
              icon
              className="h-12 w-fit gap-1 px-5 py-3"
              onClick={onGetInTouchClick}
            >
              Talk to our team{" "}
              <i className="ri-arrow-right-long-line text-md mt-0.5 font-light"></i>
            </Button>
            <Button
              className="text-muted h-12 w-fit px-5 py-3"
              variant="outline"
            >
              See how it works
            </Button>
          </div>
        </div>

        <div className="flex w-full max-w-[1034px] flex-wrap gap-2.5">
          <Badge
            variant="source"
            className="-opacity-[2%] text-md h-[38px] gap-1.5 border-neutral-400 !px-5 !py-2 leading-px font-medium tracking-normal text-neutral-500"
          >
            <i className="ri-newspaper-fill text-md mt-0.5 font-light text-neutral-500/50"></i>
            Print
          </Badge>
          <Badge
            variant="source"
            className="-opacity-[2%] text-md h-[38px] gap-1.5 border-neutral-400 !px-5 !py-2 leading-px font-medium tracking-normal text-neutral-500"
          >
            <i className="ri-global-fill text-md mt-0.5 font-light text-neutral-500/50"></i>
            Online
          </Badge>
          <Badge
            variant="source"
            className="-opacity-[2%] text-md h-[38px] gap-1.5 border-neutral-400 !px-5 !py-2 leading-px font-medium tracking-normal text-neutral-500"
          >
            <i className="ri-tv-fill text-md mt-0.5 font-light text-neutral-500/50"></i>
            TV
          </Badge>
          <Badge
            variant="source"
            className="-opacity-[2%] text-md h-[38px] gap-1.5 border-neutral-400 !px-5 !py-2 leading-px font-medium tracking-normal text-neutral-500"
          >
            <i className="ri-radio-fill text-md mt-0.5 font-light text-neutral-500/50"></i>
            Radio
          </Badge>
          <Badge
            variant="source"
            className="-opacity-[2%] text-md h-[38px] gap-1.5 border-neutral-400 !px-5 !py-2 leading-px font-medium tracking-normal text-neutral-500"
          >
            <i className="ri-global-fill text-md mt-0.5 font-light text-neutral-500/50"></i>
            Social Media
          </Badge>
        </div>
      </div>

      <img
        src="/logo/whale.svg"
        alt=""
        className="xs:h-[226px] xs:w-[505px] pointer-events-none absolute -right-30 -bottom-40 sm:h-[306px] sm:w-[685px] md:h-[366px] md:w-[745px]"
      />
    </div>
  );
}
